import React from "react";

import OfferStickyBar from "./OfferStickyBar";
import OfferPopup from "./OfferPopup";
import { isOfferActive, readPromoLang, writePromoLang } from "../../constants/promo";
import { otherPromoLang } from "./copy";

/*
  Owns the campaign's language and renders both surfaces.

  Both children position themselves independently of where this sits in the
  DOM — the bar is `position: fixed` and the popup is portalled to <body> by
  reactstrap — so one mount point can drive both, and the language switcher
  on either one keeps the other in step.
*/
class OfferCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = { lang: readPromoLang() };
  }

  toggleLang = () => {
    const lang = otherPromoLang(this.state.lang);
    writePromoLang(lang);
    this.setState({ lang });
  };

  render() {
    if (!isOfferActive()) {
      return null;
    }

    return (
      <React.Fragment>
        <OfferStickyBar lang={this.state.lang} onToggleLang={this.toggleLang} />
        <OfferPopup lang={this.state.lang} onToggleLang={this.toggleLang} />
      </React.Fragment>
    );
  }
}

export default OfferCampaign;
